import { ErrorDefinition } from "@flaminem/utils";

import { useT } from "src/internationalization";

export const useErrorDefinitions = () => {
  const t = useT();

  const fetchItemsError = (itemName: string): ErrorDefinition => ({
    title: t("error.fetch.items.title"),
    message: t("error.fetch.items.message", { itemName }),
  });

  const emptyItemsError = (
    itemName: string,
    options?: { explainText: string }
  ): ErrorDefinition => ({
    title: t("error.empty.items.title", { itemName }),
    message:
      t("error.empty.items.message", { itemName }) +
      " " +
      (options?.explainText || t("error.empty.items.text.explain")),
    type: "Warning",
  });

  return {
    "FETCH-LISTS-ERROR": fetchItemsError(t("error.item.lists")),
    "EMPTY-LISTS-ERROR": emptyItemsError(t("error.item.list"), {
      explainText: t("error.empty.items.lists.text.explain"),
    }),
    "FETCH-ELEMENT-TYPES-ERROR": fetchItemsError(t("error.item.element.types")),
    "EMPTY-ELEMENT-TYPES-ERROR": emptyItemsError(t("error.item.element.type")),
    "FETCH-IDENTIFIER-TYPES-ERROR": fetchItemsError(t("error.item.identifier.types")),
    "EMPTY-IDENTIFIER-TYPES-ERROR": emptyItemsError(t("error.item.identifier.type")),
    "FETCH-LIST-TYPES-ERROR": fetchItemsError(t("error.item.list.types")),
    "EMPTY-LIST-TYPES-ERROR": emptyItemsError(t("error.item.list.type"), {
      explainText: t("error.empty.items.list.types.text.explain"),
    }),
    "FETCH-LIST-ELEMENTS-ERROR": fetchItemsError(t("error.item.list.elements")),
    "EMPTY-LIST-ELEMENTS-ERROR": emptyItemsError(t("error.item.list.element")),
    "FETCH-CASES-ERROR": fetchItemsError(t("error.item.cases")),
    "FETCH-CASE-ERROR": fetchItemsError(t("error.item.case")),
    "FETCH-USERS-ERROR": fetchItemsError(t("error.item.users")),
    "FETCH-USER-ERROR": fetchItemsError(t("error.item.user")),
    "FETCH-ALERTS-ERROR": fetchItemsError(t("error.item.alerts")),
    "FETCH-SCENARIOS-ERROR": fetchItemsError(t("error.item.scenarios")),
    "EMPTY-SCENARIOS-ERROR": emptyItemsError(t("error.item.scenario")),
    "FETCH-SCENARIO-ERROR": fetchItemsError(t("error.item.scenario")),
    "FETCH-PERMISSIONS-ERROR": fetchItemsError(t("error.item.permissions")),
    "FETCH-BLACKLIST-IDENTIFIERS-ERROR": fetchItemsError(t("error.item.blacklist.identifiers")),
    "EMPTY-PERMISSIONS-ERROR": {
      title: t("error.empty.item.permissions.title"),
      message: t("error.empty.item.permissions.message"),
    },
    "FETCH-CASE-TYPES-ERROR": fetchItemsError(t("error.item.case.types")),
    "EMPTY-CASE-TYPES-ERROR": emptyItemsError(t("error.item.case.type")),
    "FETCH-BLACKLIST-TYPES-ERROR": fetchItemsError(t("error.item.blacklist.types")),
    "EMPTY-BLACKLIST-TYPES-ERROR": emptyItemsError(t("error.item.blacklist.type")),
    "FETCH-RELATED-CASES-ERROR": fetchItemsError(t("error.item.related.cases")),
    "FETCH-LIST-SPECIFICATIONS-ERROR": fetchItemsError("spécifications d’import"),
    "FETCH-CONFLIST-ERROR": fetchItemsError(t("error.fetch.confList")),
    "EMPTY-CONFLIST-ERROR": emptyItemsError(t("error.empty.confList")),
    "UNKNOWN-ERROR": {
      title: t("error.unknown.title"),
      message: t("error.unknown.message"),
    },
    "SERVER-ERROR": {
      title: t("error.server.title"),
      message: t("error.server.message"),
    },
    "FETCH-OPERATORS-ERROR": fetchItemsError(t("error.item.operators")),
    "EMPTY-OPERATORS-ERROR": emptyItemsError(t("error.item.operator")),
    "FETCH-PROPERTIES-ERROR": fetchItemsError(t("error.item.properties")),
  };
};
